export default "__VITE_ASSET__2b916afd__"